var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDaphne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_308",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29242",
    "data-name": "Group 29242",
    transform: "translate(286 10837)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28370",
    "data-name": "Group 28370",
    transform: "translate(-277 -10831)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Ellipse_308)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_308-2",
    "data-name": "Ellipse 308",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_50261",
    "data-name": "Path 50261",
    d: "M38.808,14a33.382,33.382,0,0,0,1.081,5.629,5.829,5.829,0,0,1-1.081,5.9c-2.476,2.606,3.614,5.651-1.216,9.277-3.644,2.736-9.592-.63-9.592-.63V27.691Z",
    transform: "translate(-274.265 -10824.952)",
    fill: "#f57c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50262",
    "data-name": "Path 50262",
    d: "M27.021,37.21H19.815l-.477-9.774,7.683,1.127Z",
    transform: "translate(-271.845 -10828.706)",
    fill: "#efad60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50263",
    "data-name": "Path 50263",
    d: "M19,21.529s1.84,7.141,6.884,7.141c1.978.015,3.042-1.823,4.645-3.538,1.077-1.151,2.1-1.939,2.392-3.1.721-2.882.491-4.109,1.932-6.27S24.764,10,24.764,10L19,13.6Z",
    transform: "translate(-271.75 -10823.834)",
    fill: "#ffcc80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50264",
    "data-name": "Path 50264",
    d: "M26.843,20.681s-.207-3.082-3.588-2.322C23.255,21.96,26.843,20.681,26.843,20.681Z",
    transform: "translate(-272.94 -10826.136)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50265",
    "data-name": "Path 50265",
    d: "M31.287,19.777a3.326,3.326,0,0,0-.368,3.38c.275.757-.337,1.044-1.345,1.173-.652.084-.615.741-.166.793.471.081,2.679-.241,2.294-1.984C31.413,21.841,30.8,21.271,31.287,19.777Z",
    transform: "translate(-274.566 -10826.566)",
    fill: "#efad60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50266",
    "data-name": "Path 50266",
    d: "M33,21.46s.774-2.223,3.856-1.05A2.239,2.239,0,0,1,33,21.46Z",
    transform: "translate(-275.663 -10826.647)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50267",
    "data-name": "Path 50267",
    d: "M26.362,29.8l1.866-.352a.834.834,0,0,0,1.2.138l1.261.935a3.156,3.156,0,0,1-2.162.721A2.665,2.665,0,0,1,26.362,29.8Z",
    transform: "translate(-273.808 -10829.269)",
    fill: "#e57373"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50268",
    "data-name": "Path 50268",
    d: "M16.983,44.02a11.6,11.6,0,0,0,12.25-.721V38.976a29.9,29.9,0,0,1-8.647,0C16.262,38.255,16.983,44.02,16.983,44.02Z",
    transform: "translate(-271.174 -10831.914)",
    fill: "#7cb342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50269",
    "data-name": "Path 50269",
    d: "M33.755,39.235a26.656,26.656,0,0,1,3.312,6.021H29.93L29.558,40.3c-.053-.775-.938-1.133-2.388-1.208l1.073-.643C29.116,37.929,32.89,38.14,33.755,39.235Z",
    transform: "translate(-274.034 -10831.708)",
    fill: "#9ccc65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50270",
    "data-name": "Path 50270",
    d: "M30.822,7.221A3.122,3.122,0,0,1,32.263,10.1c0,2.162-2.206,4.1-6.53,3.378s-8.257-4.838-8.257-4.838-.345,4.342-2.507,5.783c-.721,3.6.421,6.27,1.862,9.153a7.457,7.457,0,0,1-1.276,9C12.76,35.273,3.531,36.268,2,28.837c1.372,1.572,4.233-.4,2.792-2.567S2,20.191,7.044,15.867C8.117,9.091,10.9,2.345,17.89.445,24.149-1.257,30.822,2.9,30.822,7.221Z",
    transform: "translate(-267 -10821.055)",
    fill: "#f57c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50271",
    "data-name": "Path 50271",
    d: "M20.162,10.206a8.828,8.828,0,0,1,7.926-4.323c5.764,0,8.313,3.446,8.313,3.446L35.293,6.6A8.492,8.492,0,0,0,28.088,3C23.044,3,18.721,8.044,18,11.647A6.276,6.276,0,0,1,20.162,10.206Z",
    transform: "translate(-271.471 -10821.878)",
    fill: "#b388ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50272",
    "data-name": "Path 50272",
    d: "M23.255,18.359A2.763,2.763,0,0,0,23.8,20.2a1.18,1.18,0,0,0,1.193-1.867A3.668,3.668,0,0,0,23.255,18.359Z",
    transform: "translate(-272.94 -10826.138)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50273",
    "data-name": "Path 50273",
    d: "M33.054,21.4a1.118,1.118,0,0,0,.071.195,2.278,2.278,0,0,0,1.2.589,1.076,1.076,0,0,0,.277-2A2.259,2.259,0,0,0,33.054,21.4Z",
    transform: "translate(-275.678 -10826.68)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50274",
    "data-name": "Path 50274",
    d: "M22.952,16.154c2.8-1.109,2.76.9,4.312,1.38C25.367,18.051,25.781,15.809,22.952,16.154Z",
    transform: "translate(-272.855 -10825.462)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50275",
    "data-name": "Path 50275",
    d: "M19.169,11.191s-.055,2.263-4.526,4.416c-2.624,1.264-3.422,4.14-3.7,6.347-.166-5.078,1.932-6.623,3.422-7.4S18.451,12.406,19.169,11.191Z",
    transform: "translate(-269.497 -10824.167)",
    fill: "#ef6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50276",
    "data-name": "Path 50276",
    d: "M20.991,11.973A10.089,10.089,0,0,1,17.2,17.8a7.647,7.647,0,0,0-2.53,6.991s.368-4.047,2.714-5.841A8.587,8.587,0,0,0,20.991,11.973Z",
    transform: "translate(-270.514 -10824.386)",
    fill: "#ef6c00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaphne);
export default __webpack_public_path__ + "static/media/daphne.4d5a08795cad8e2724474a832923d2c2.svg";
export { ForwardRef as ReactComponent };